import { alpha } from "@mui/material/styles";

export const isRemakeOrderItem = (item) =>
  item?.is_remake === 1 ||
  item?.is_remake === "1" ||
  item?.is_remake === true;

export const getOrderItemRowSx = (item, { skipRemakeHighlight = false } = {}) => {
  if (!skipRemakeHighlight && isRemakeOrderItem(item)) {
    return (theme) => ({
      backgroundColor: alpha(theme.palette.secondary.main, 0.08),
      boxShadow: `inset 3px 0 0 ${theme.palette.secondary.main}`,
      "&:hover": {
        backgroundColor: alpha(theme.palette.secondary.main, 0.12),
      },
    });
  }

  if (
    item?.catalog?.print_provider !== null &&
    item?.catalog?.print_provider !== undefined
  ) {
    return { backgroundColor: "#F0FFFF" };
  }

  return undefined;
};
